"use client";

import clsx from "clsx";

import { Breadcrumb } from "@/components/Breadcrumb";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useProductStoreBreadcrumb } from "@/hooks/use-product-store-breadcrumb";

interface Props {
  children: React.ReactNode;
}

export default function WithBreadcrumbLayout({ children }: Props) {
  const { breadcrumbItems, isGalleryPage } = useProductStoreBreadcrumb();

  return (
    <div className="flex min-h-screen flex-col">
      <Header className="!mb-0" />

      <div className="mb-1 mt-3 flex w-full justify-center px-page-x-margin lg:mb-2 lg:mt-2">
        <div className="w-full max-w-page-max-width">
          {breadcrumbItems.length ? (
            <Breadcrumb
              items={breadcrumbItems}
              className={clsx({
                "max-lg:hidden": history.length === 1 && isGalleryPage,
              })}
            />
          ) : (
            <div role="none" className="h-5 lg:h-6" />
          )}
        </div>
      </div>

      {children}

      <Footer />
    </div>
  );
}
